module.exports = __webpack_public_path__ + "img/entretient-3.49da698f.jpg";